import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import InsuranceCompaniesMultiSelectWithCheckList from './InsuranceCompaniesMultiSelectWithCheckList';

const InsuranceCompaniesMultiSelectWithCheckListField: React.FC<
	BaseFieldProps
> = props => (
	<BaseField {...props}>
		<InsuranceCompaniesMultiSelectWithCheckList portal={props.portal} />
	</BaseField>
);

export default InsuranceCompaniesMultiSelectWithCheckListField;
